import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { Tradable } from "@models/interfaces/tradable";

@Component({
	selector: "buy-again",
	templateUrl: "./buy-again.component.html",
	styleUrls: ["./buy-again.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BuyAgainComponent {
	@Input() public tradables: Tradable[] = [];
	@Output() public onTradableClick: EventEmitter<Tradable> = new EventEmitter<Tradable>();
}
